import React from 'react';
import PropTypes from 'prop-types';
import LockIcon from './icons/LockIcon';

// eslint-disable-next-line func-names
const MainNavLinks = function (props) {
  const { mode } = props;

  const displayMode = mode === undefined ? 'header' : mode;
  const ulClassName =
    displayMode === 'header'
      ? 'umnHeaderMainNavLinksUl-header'
      : 'umnHeaderMainNavLinksUl';

  const aClassName =
    displayMode === 'header'
      ? 'umnHeaderMainNavLinksA-header'
      : 'umnHeaderMainNavLinksA';

  const MainNavLinksCSS = `
      .umnHeaderMainNavLinksUl,
.umnHeaderMainNavLinksUl-header {
  margin: 0;
  list-style-type: none;
  display: none;
}

.umnHeaderMainNavLinksUl-header {
  position: absolute;
  right: 54px;
  top: 8px;
}

@media (max-width: 775px) {
  .umnHeaderMainNavLinksUl-header {
    display: none;
  }
  .umnHeaderMainNavLinksUl {
    display: block;
  }
}
@media (min-width: 776px) {
  .umnHeaderMainNavLinksUl-header {
    display: block;
  }
  .umnHeaderMainNavLinksUl {
    display: none;
  }
}

.umnHeaderMainNavLinksLi {
  margin: 0;
  display: inline-block;
  margin-left: 1.25rem;
}

.umnHeaderMainNavLinksA,
.umnHeaderMainNavLinksA-header {
  text-decoration: none;
  color: #404d5b;
}
.umnHeaderMainNavLinksA-header {
  color: #fff;
}
.umnHeaderMainNavLinksA:hover,
.umnHeaderMainNavLinksA:focus {
  text-decoration: underline;
  color: #404d5b;
}
.umnHeaderMainNavLinksA-header:hover,
.umnHeaderMainNavLinksA-header:focus {
  text-decoration: underline;
  color: #fff;
}

@media print{
  .${ulClassName}{display:none !important}
}

      `;

  return (
    <div>
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: MainNavLinksCSS,
        }}
      />
      <ul className={ulClassName}>
        <li className='umnHeaderMainNavLinksLi'>
          <a href='http://onestop.umn.edu/' className={aClassName}>
            One Stop
          </a>
        </li>
        <li className='umnHeaderMainNavLinksLi'>
          <a href='https://www.myu.umn.edu/' className={aClassName}>
            <span>MyU </span>
            <LockIcon color={displayMode === 'header' ? '#fff' : '#404d5b'} />
          </a>
        </li>
      </ul>
    </div>
  );
};

MainNavLinks.propTypes = {
  mode: PropTypes.string,
};

MainNavLinks.defaultProps = {
  mode: 'header',
};

export default MainNavLinks;
